module.exports = __webpack_public_path__ + "img/image 13.870f0db9.png";